{
  "core_fields": {
    "first_name": "First Name",
    "last_name": "Last Name",
    "nick_name": "Nickname",
    "full_name": "Full Name",
    "role": "Role",
    "import_id": "Import ID",
    "contact_type": "Contact Type",
    "resource_type_id": "Resource Type",
    "represented_by_id": "Represented By",
    "profile_picture": "Profile Picture",
    "rates": "Rates",
    "tags": "Tags",
    "groups": "Groups",
    "locations": "Locations",
    "emails": "Emails",
    "websites": "Websites",
    "phone_numbers": "Phone Numbers",
    "socials": "Socials",
    "pronouns": "Pronouns",

    "code": "Code",
    "icon": "Icon",
    "title": "Title",
    "production_type_id": "Production Type",
    "production_template_id": "Production Template",
    "production_date": "Production Date",
    "shotflow_instance": "Shotflow Instance",
    "status_id": "Status",
    "description": "Description",
    "color": "Color",
    "timezone": "Timezone",
    "events": "Schedule",
    "production_locations": "Locations",
    "budget_amount": "Budget Amount",
    "estimated_total": "Estimated Total",
    "actual_total": "Actual Total",
    "budget_expenses": "Budget Expenses",
    "budget_expenses.name": "Name",
    "budget_expenses.description": "Description",
    "budget_expenses.estimate": "Estimate",
    "budget_expenses.archived": "Archived",
    "budget_expenses.group_id": "Group",
    "budget_expenses.slot_category_id": "Category",
    "budget_expenses.expenses": "Expenses",
    "budget_expenses.expenses.booking_id": "Booking",
    "budget_expenses.expenses.booking.resource_id": "Resource",
    "budget_expenses.expenses.commit_vendor": "Vendor",
    "budget_expenses.expenses.commit": "Committed",
    "budget_expenses.expenses.created_at": "Created At",
    "budget_expenses.expenses.updated_at": "Updated At",
    "budget_expenses.expenses.slot_category_id": "Category",
    "budget_expenses.expenses.receipts": "Receipts",
    "resourcing_at": "Resourcing At",
    "ready_at": "Ready At",
    "completed_at": "Completed At",
    "cancelled_at": "Cancelled At",

    "booking_type_id": "Booking Type",
    "rate": "Rate",
    "note": "Note",
    "contracts": "Contracts",
    "invoices": "Invoices",
    "submitted_date": "Submitted Date",
    "agreed_date": "Agreed Date",
    "pencilled_at": "Pencilled At",
    "confirmed_at": "Confirmed At",

    "createdAt": "Created At",
    "updatedAt": "Updated At",
    "archived": "Archived",
    "user_id": "Owner",

    "bookings": "Bookings",

    "public_id": "Public ID",
    "status": "Status",
    "public_title": "Public Title",
    "public_description": "Public Description",
    "confirmation_text": "Confirmation Text",
    "enable_notifications": "Enable Notifications",
    "published": "Published",
    "deadline": "Deadline",
    "public": "Public",
    "expanded": "Expanded",
    "public_feedback": "Public Feedback",
    "layout": "Layout",
    "enable_voting": "Enable Voting",
    "enable_commenting": "Enable Commenting",

    "billing": "Billing",
    "social": "Social",
    "hard_drive": "Hard Drive",
    "from_date": "From Date",
    "to_date": "To Date",
    "call_time": "Call Time",

    "resource_slots": "Resource Slots",
    "resource": "Resource",
    "resource_slot_assignments": "Resource Slots",

    "organisation": "Organisation",
    "organisation_id": "Organisation",
    "availability": "Availability",
    "all": "All",
    "published_at": "Published At",
    "callsheet_date": "Callsheet Date"
  },
  "rate_intervals": {
    "DAILY": "Daily",
    "HOURLY": "Hourly",
    "FIXED": "Fixed",
    "ITEM": "Per Item"
  },
  "rateInput": {
    "currencyAria": "Currency",
    "amountAria": "Rate amount",
    "intervalAria": "Billing unit",
    "quantityAria": "Quantity",
    "currencyTooltip": "Currency used for this rate.",
    "amountTooltip": "Rate amount (before quantity and fees).",
    "intervalTooltip": "How this rate is billed, e.g. per hour or per day.",
    "multiplyTooltip": "Rate is multiplied by quantity for the line total.",
    "quantityTooltip": "How many units this rate applies to."
  },
  "dynamicUi": {
    "fileField": {
      "dropFilesOrClick": "Drop files here, click to select, or paste",
      "acceptMimeImageAll": "images",
      "acceptMimeVideoAll": "videos",
      "acceptMimePdf": "PDF documents",
      "weAccept": "We accept",
      "atLeastOneFileRequired": "At least one file is required",
      "uploadFailed": "Upload failed",
      "noFilesUploaded": "No files uploaded"
    }
  },
  "validation": {
    "required": "This field is required",
    "url": "Not a valid link",
    "email": "Not a valid email address",
    "phone_number": "Not a valid phone number"
  },
  "standard-date-filter": {
    "timestamp": {
      "last7Days": "Last 7 days",
      "last30Days": "Last 30 days",
      "last90Days": "Last 90 days"
    },
    "scheduled": {
      "today": "Today",
      "tomorrow": "Tomorrow",
      "nextWeek": "Next week",
      "nextMonth": "Next month"
    },
    "custom": {
      "last7Days": "Last 7 days",
      "last30Days": "Last 30 days",
      "last90Days": "Last 90 days",
      "today": "Today",
      "tomorrow": "Tomorrow",
      "nextWeek": "Next week",
      "nextMonth": "Next month"
    }
  },
  "AccountSettingsPronouns": {
    "sectionLabel": "Resources",
    "title": "Pronouns options",
    "description": "Define which pronoun labels appear when editing people (Individual, Talent, Agent).",
    "listTitle": "Allowed pronouns",
    "help": "These values are validated when saving a resource. Drag the handle to reorder; duplicate entries are removed on save.",
    "dragHandleLabel": "Drag to reorder",
    "optionPlaceholder": "e.g. They/Them",
    "addOption": "Add option",
    "remove": "Remove",
    "save": "Save",
    "saved": "Pronouns options saved",
    "saveFailed": "Could not save pronouns options"
  },
  "online_status": {
    "online": "You're online",
    "offline": "You're offline",
    "toast_offline": "You're offline",
    "toast_online": "You're back online"
  },
  "enterprise": {
    "globalScopeLabel": "Global",
    "loadingWorkspaces": "Loading workspaces…",
    "workspacesUnavailable": "Workspaces unavailable",
    "emptyWorkspaces": "No workspaces available",
    "emptyWorkspacesHint": "This should not happen. Contact support if you see this.",
    "teamsSectionLabel": "Teams",
    "loadingTeams": "Loading teams…",
    "teamsUnavailable": "Teams unavailable",
    "emptyTeams": "No teams in this workspace",
    "emptyTeamsHint": "This should not happen. Contact support if you see this.",
    "teamsSettingsLabel": "Team settings",
    "newTeam": "New team",
    "newWorkspace": "New workspace",
    "createWorkspace": "Create workspace",
    "createWorkspaceDescription": "Add a new enterprise workspace to your organization.",
    "editWorkspace": "Edit workspace",
    "editWorkspaceDescription": "Update workspace name and icon.",
    "createTeam": "Create team",
    "createTeamDescription": "Add a new team under this workspace.",
    "editTeam": "Edit team",
    "editTeamDescription": "Update team name, icon, and color.",
    "archive": "Archive",
    "unarchive": "Restore",
    "activeTab": "Active",
    "archivedTab": "Archived",
    "emptyArchivedWorkspaces": "No archived workspaces",
    "emptyArchivedTeams": "No archived teams in this workspace",
    "edit": "Edit",
    "create": "Create",
    "save": "Save",
    "fieldName": "Name",
    "fieldIcon": "Icon",
    "fieldIconColor": "Icon color",
    "pickIconColor": "Pick a color",
    "iconUploadHint": "Drop an image, click to upload, or paste",
    "uploadIcon": "Upload icon",
    "removeIcon": "Remove",
    "iconUploadError": "Failed to upload icon",
    "manageEntity": "Manage",
    "manageEnterprise": "Manage enterprise",
    "manageEnterpriseDescription": "Create, edit, and archive workspaces and teams in your organization.",
    "workspacesTitle": "Workspaces",
    "teamsTitle": "Teams",
    "teamsForWorkspace": "Teams in {{workspace}}",
    "selectWorkspaceHint": "Select a workspace to manage its teams"
  },
  "resourceTypesAdmin": {
    "globalTitle": "Resource types",
    "globalDescription": "Manage system wide resource types that are synced across workspaces.",
    "workspaceTitle": "Resource types",
    "workspaceDescription": "Manage resource types that are visible in this workspace and manage specific workspace fields.",
    "name": "Name",
    "type": "Type",
    "workspaces": "Workspaces",
    "assignWorkspaces": "Manage workspaces",
    "searchWorkspaces": "Search workspaces…",
    "openInWorkspace": "Open {{workspace}} settings",
    "workspacesTabHint": "Resource types are not assigned to workspaces by default. Enable them where they should appear.",
    "workspacesSearchNoResults": "No workspaces found",
    "workspacesTabEmpty": "No workspaces in this organization yet",
    "workspacesLoadError": "Couldn't load workspaces",
    "newResourceType": "New resource type",
    "createTitle": "Create resource type",
    "createDescription": "Create a resource type available across the organization.",
    "fieldName": "Name",
    "fieldIcon": "Icon",
    "fieldMechanism": "Type",
    "mechanismLockedHint": "Cannot be edited once created.",
    "chooseIcon": "Choose icon",
    "active": "Active",
    "inactive": "Inactive",
    "activate": "Activate",
    "deactivate": "Deactivate",
    "activateFieldTitle": "Activate field?",
    "activateFieldDescription": "Are you sure you want to activate this field?",
    "deactivateFieldTitle": "Deactivate field?",
    "deactivateFieldDescription": "Are you sure you want to deactivate this field? You will not lose any data.",
    "edit": "Edit",
    "archive": "Archive",
    "unarchive": "Restore",
    "archiveSuccess": "Resource type archived",
    "unarchiveSuccess": "Resource type restored",
    "enable": "Enable in workspace",
    "disable": "Disable in workspace",
    "enableSuccess": "Resource type enabled in workspace",
    "disableSuccess": "Resource type disabled in workspace",
    "disabledInWorkspaceTitle": "This resource type is disabled in {{workspace}}",
    "disabledInWorkspaceDescription": "Members of this workspace won't see resources of this type until it's enabled.",
    "disableConfirmTitle": "Disable resource types?",
    "disableConfirmDescription": "Selected resource types will no longer appear in this workspace. You will not lose any data.",
    "detailsTab": "Details",
    "detailsSaveSuccess": "Resource type saved",
    "detailsSaveFailed": "Couldn't save resource type",
    "fieldsTab": "Fields",
    "globalDetailSubtitle": "Edit this resource type for all workspaces.",
    "workspaceDetailSubtitle": "Edit workspace-specific options for this resource type. To edit more about this resource type navigate to the Global Resource Types page.",
    "viewGlobalSettings": "View global settings",
    "viewGlobalResourceTypes": "View global resource types",
    "globalFieldsTitle": "Global fields",
    "globalFieldsHint": "Fields edited and added here will be applied to all workspaces. To edit workspace specific fields head to the workspace settings.",
    "workspaceGlobalFieldsHint": "Global fields are only editable outside the workspace within the global configurations.",
    "configureGlobalFields": "Configure global fields",
    "workspaceFieldsTitle": "{{workspace}} fields",
    "workspaceFallbackName": "Workspace",
    "required": "Required",
    "locked": "Locked",
    "filterable": "Filterable",
    "requiredEnabledToast": "Field marked as required",
    "requiredDisabledToast": "Field no longer required",
    "filterableEnabledToast": "Field is now filterable",
    "filterableDisabledToast": "Field is no longer filterable",
    "fieldPropertyUpdateError": "Couldn't update field",
    "fieldType": "Type",
    "addField": "Add field",
    "addFieldAssignPrompt": "This will be added to",
    "searchFields": "Search fields…",
    "fieldsSearchNoResults": "No fields found",
    "dangerousActions": "Dangerous actions",
    "archiveSectionTitle": "Archive resource type",
    "archiveSectionDescription": "Data will be preserved but users across workspaces will no longer see this resource type",
    "unarchiveSectionTitle": "Restore resource type",
    "unarchiveSectionDescription": "Restore this resource type so it can be enabled in workspaces again.",
    "entityNameSingular": "resource type",
    "entityNamePlural": "resource types",
    "fieldEntityNameSingular": "field",
    "fieldEntityNamePlural": "fields",
    "batchArchiveSelected": "Archive selected",
    "batchUnarchiveSelected": "Restore selected",
    "batchActivateSelected": "Activate selected",
    "batchDeactivateSelected": "Deactivate selected",
    "batchActivateFieldsNone": "No fields to activate",
    "batchDeactivateFieldsNone": "Locked system fields can't be deactivated",
    "batchEnableSelected": "Enable selected",
    "batchDisableSelected": "Disable selected",
    "reorderFields": "Reorder field",
    "emptyActive": "No active resource types",
    "emptyInactive": "No inactive resource types",
    "emptyArchived": "No archived resource types",
    "emptyFields": "No fields yet",
    "emptyInactiveFields": "No inactive fields",
    "loadError": "Couldn't load this resource type",
    "localPreviewNote": "Workspace enablement and fields are saved locally in this browser until the backend supports them.",
    "assignResourceTypesAction": "Enable resource types",
    "assignResourceTypesTitle": "Enable resource types",
    "assignResourceTypesSearchPlaceholder": "Search resource types…",
    "assignResourceTypesSelectedCount": "{{count}} selected",
    "assignResourceTypesSelectPrompt": "Select resource types to enable in this workspace",
    "assignResourceTypesUnselectAll": "Unselect all",
    "assignResourceTypesEmpty": "All resource types are already enabled in this workspace",
    "assignResourceTypesNoResults": "No resource types found",
    "assignResourceTypesConfirm": "Enable ({{count}})",
    "assignResourceTypesLoadError": "Couldn't load resource types",
    "create": "Create",
    "createFailed": "Couldn't create resource type",
    "unsavedChangesBeforeUnload": "You have unsaved changes!",
    "cancel": "Cancel",
    "mechanisms": {
      "INDIVIDUAL": "Individual",
      "ORGANIZATION": "Organization",
      "LOCATION": "Location",
      "ITEM": "Item",
      "TALENT": "Talent",
      "AGENT": "Agent"
    }
  },
  "app_update": {
    "message": "A new version of the app is available.",
    "refresh": "Refresh"
  },
  "app_crash": {
    "title": "Something Went Wrong",
    "description": "The app has crashed. Please refresh and try again or contact us for help",
    "refresh": "Refresh",
    "goToDashboard": "Go to dashboard",
    "errorLogLabel": "Error details"
  },
  "server_unreachable": {
    "bootstrap": {
      "title": "Couldn't load the app",
      "description_connection": "We couldn't connect to the server. Check your connection and refresh.",
      "description_server": "The server returned an error while loading required data. Try again in a moment."
    },
    "session": {
      "title": "Couldn't load your session",
      "description_connection": "We couldn't reach the server to load your account settings. Check your connection and refresh.",
      "description_server": "Your account settings couldn't be loaded due to a server error. Try again in a moment."
    },
    "sign_in": {
      "title": "Sign-in unavailable",
      "description_connection": "We couldn't connect to verify sign-in options. Check your connection and refresh.",
      "description_server": "Sign-in is temporarily unavailable due to a server error. Try again in a moment."
    },
    "refresh": "Refresh",
    "goToDashboard": "Go to dashboard",
    "errorLogLabel": "Error details"
  },
  "not_found": {
    "title": "Sorry, we can't find what you're looking for",
    "description": "Check the link is correct or make sure you are logged in. If you are still having issues we are here to help!",
    "contactSupport": "Contact support",
    "goToDashboard": "Go to dashboard",
    "contact": {
      "title": "Cannot find contact",
      "description": "This contact may be archived, or you may have the wrong link"
    },
    "production": {
      "title": "Cannot find production",
      "description": "This production may be archived, or you may have the wrong link"
    },
    "callout": {
      "title": "Cannot find callout",
      "description": "This callout may be archived, or you may have the wrong link"
    },
    "callsheet": {
      "title": "Cannot find callsheet",
      "description": "This callsheet may be archived, or you may have the wrong link"
    },
    "shortlist": {
      "title": "Cannot find shortlist",
      "description": "This shortlist may be archived, or you may have the wrong link"
    }
  }
}
